import { Pipe, PipeTransform } from '@angular/core';
import { HighlightedProductsService } from '@core/services/highlighted-products.service';

@Pipe({
  name: 'isProductHighlighted',
  standalone: true,
})
export class IsProductHighlightedPipe implements PipeTransform {
  constructor(private highlightedProductsService: HighlightedProductsService) {}

  transform(idProduct: number): boolean {
    return this.highlightedProductsService.isProductHighlighted(idProduct);
  }
}
